export const BRAND_KEY = {
  BREDECO: 'bredeco',
  FROMM_AND_STARCK: 'Fromm & Starck',
  GOLDBRUNN: 'goldbrunn',
  GYMREX: 'Gymrex',
  HILLVERT: 'hillvert',
  INCUBATO: 'incubato',
  MSW: 'MSW',
  PHYSA: 'physa',
  ROYAL_CATERING: 'Royal Catering',
  SINGERCON: 'Singercon',
  STAMONY: 'Stamony',
  STAMOS: 'Stamos',
  STEINBERG: 'Steinberg',
  ULSONIX: 'ulsonix',
  UNIPRODO: 'Uniprodo',
  WIESENFIELD: 'Wiesenfield',
} as const;

export type BrandKey = ValueOf<typeof BRAND_KEY>;

export type RawBrand = {
  logo: string,
  url?: string,
  internalUrl?: string,
  footerDisplayName?: string,
  subBrands?: string[],
  gtmId?: string,
}

export const BRANDS: Record<BrandKey, RawBrand> = {
  [BRAND_KEY.BREDECO]: {
    logo: '/brands/Bredeco.svg',
  },
  [BRAND_KEY.FROMM_AND_STARCK]: {
    logo: '/brands/Fromm_and_Starck.svg',
    internalUrl: '/frommstarck/',
    footerDisplayName: 'Fromm & Starck',
    gtmId: 'fromm-and-starck',
  },
  [BRAND_KEY.GOLDBRUNN]: {
    logo: '/brands/Goldbrunn.svg',
  },
  [BRAND_KEY.GYMREX]: {
    logo: '/brands/Gymrex.svg',
  },
  [BRAND_KEY.HILLVERT]: {
    logo: '/brands/Hillvert.svg',
    internalUrl: '/hillvert/',
    footerDisplayName: 'hillvert',
    gtmId: 'hillvert',
  },
  [BRAND_KEY.INCUBATO]: {
    logo: '/brands/Incubato.svg',
  },
  [BRAND_KEY.MSW]: {
    logo: '/brands/MSW.svg',
    url: 'https://www.msw24.com',
    internalUrl: '/msw/',
    footerDisplayName: 'MSW Motor Technics',
    gtmId: 'msw',
  },
  [BRAND_KEY.PHYSA]: {
    logo: '/brands/Physa.svg',
    internalUrl: '/physa/',
    footerDisplayName: 'physa',
    gtmId: 'physa',
  },
  [BRAND_KEY.ROYAL_CATERING]: {
    logo: '/brands/Royal_Catering.svg',
    url: 'https://www.cateringroyal.de',
    internalUrl: '/royal-catering/',
    footerDisplayName: 'Royal Catering',
    gtmId: 'royal-catering',
  },
  [BRAND_KEY.SINGERCON]: {
    logo: '/brands/Singercon.svg',
  },
  [BRAND_KEY.STAMONY]: {
    logo: '/brands/Stamony.svg',
  },
  [BRAND_KEY.STAMOS]: {
    logo: '/brands/Stamos.svg',
    internalUrl: '/stamos/',
    footerDisplayName: 'STAMOS',
    subBrands: [
      'Stamos',
      'Stamos Welding Group',
      'Stamos Soldering',
      'Stamos Germany',
      'Stamos Power ²',
      'Stamos Selection',
      'Stamos Basic',
      'Stamos Pro Series',
      'Stamos ECO',
    ],
    gtmId: 'stamos',
  },
  [BRAND_KEY.STEINBERG]: {
    logo: '/brands/Steinberg.svg',
    internalUrl: '/steinberg-systems/',
    footerDisplayName: 'Steinberg Systems',
    subBrands: [
      'Steinberg',
      'Steinberg Systems',
      'Steinberg Basic',
    ],
    gtmId: 'steinberg',
  },
  [BRAND_KEY.ULSONIX]: {
    logo: '/brands/Ulsonix.svg',
    internalUrl: '/ulsonix/',
    footerDisplayName: 'ulsonix',
    gtmId: 'ulsonix',
  },
  [BRAND_KEY.UNIPRODO]: {
    logo: '/brands/Uniprodo.svg',
    internalUrl: '/uniprodo/',
    footerDisplayName: 'Uniprodo',
    gtmId: 'uniprodo',
  },
  [BRAND_KEY.WIESENFIELD]: {
    logo: '/brands/Wiesenfield.svg',
    internalUrl: '/wiesenfield/',
    footerDisplayName: 'Wiesenfield',
    gtmId: 'wiesenfield',
  },
} as const;

export const BRANDS_WTH_SUBBRANDS: BrandKey[] = Object.values(BRAND_KEY).filter(
  (key) => Boolean(BRANDS[key].subBrands),
);

export const OUR_BRANDS_KEYS: BrandKey[] = [
  BRAND_KEY.ROYAL_CATERING,
  BRAND_KEY.STAMOS,
  BRAND_KEY.MSW,
  BRAND_KEY.STEINBERG,
  BRAND_KEY.ULSONIX,
  BRAND_KEY.HILLVERT,
  BRAND_KEY.PHYSA,
  BRAND_KEY.WIESENFIELD,
  BRAND_KEY.FROMM_AND_STARCK,
  BRAND_KEY.UNIPRODO,
];

export type BrandDefinition = ValueOf<typeof BRANDS>;

export type BrandInfo = BrandDefinition & {
  name: string,
};
